import safelyParseJson from './safelyParseJson';

const LocalStorageWrapper = {
  getItem: (key: string): ObjectType => {
    const item = safelyParseJson(localStorage.getItem(key));
    return item as ObjectType;
  },
  setItem: (key: string, value: ObjectType): void => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key: string): void => {
    localStorage.removeItem(key);
  },
};

export default LocalStorageWrapper;
